import { XIcon } from 'lucide-react'
import { type FC, memo, type ReactNode, useCallback } from 'react'

import { Button } from '@/components/ui/button'
import { ChatFileChip } from './chat-file-chip.atom'
import type { ChatAttachment } from './chat-input-attachment.interface'

export interface ChatInputFilePreviewProps {
  attachment: ChatAttachment

  onRemove: (id: string) => void

  className?: string
}

const ChatInputFilePreviewBase: FC<ChatInputFilePreviewProps> = ({
  attachment,
  onRemove,
  className,
}): ReactNode => {
  const handleRemove = useCallback(() => {
    onRemove(attachment.id)
  }, [attachment.id, onRemove])

  return (
    <ChatFileChip
      filename={attachment.name}
      mimeType={attachment.mimeType}
      sizeBytes={attachment.size}
      semanticClass="chat-input-file-preview"
      className={className}
    >
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={handleRemove}
        className="chat-input-file-remove -mr-1 size-5 shrink-0 rounded-sm hover:bg-destructive/10 hover:text-destructive"
        aria-label={`Remove ${attachment.name}`}
      >
        <XIcon className="size-3" />
      </Button>
    </ChatFileChip>
  )
}

export const ChatInputFilePreview = memo(ChatInputFilePreviewBase)

ChatInputFilePreview.displayName = 'ChatInputFilePreview'
